import { render } from "./DemandCategoryManager.vue?vue&type=template&id=6005a092"
import script from "./DemandCategoryManager.vue?vue&type=script&lang=js"
export * from "./DemandCategoryManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__